import { useAuthStore } from '../stores/auth.store'
import { useSellerFilterStore } from '../stores/seller-filter.store'

export function useSelectedSeller() {
  const nivelAcesso = useAuthStore((state) => state.nivelAcesso)
  const selectedSeller = useSellerFilterStore((state) => state.selectedSeller)
  return nivelAcesso === 3 ? selectedSeller : ''
}
